import moment from 'moment';
import 'moment-timezone';

export const currentUtcMillis = () => {
  return moment().utc().valueOf();
};

// If provided date is not of specified format, for example, just date, no time
export const unspecifiedDateToMillis = (date) => {
  const momentUtcDate = moment(date);
  const dateMillis = momentUtcDate.valueOf() + momentUtcDate.utcOffset() * 60 * 1000;

  return dateMillis;
};

export const unspecifiedDateToUtcMillis = (date) => {
  const momentUtcDate = moment(date);
  const dateMillis = momentUtcDate.valueOf() - momentUtcDate.utcOffset() * 60 * 1000;

  return dateMillis;
};

// If provided date is of UTC format, for example has Z at the end
export const utcDateToMillis = (date) => {
  const momentUtcDate = moment(date);
  const dateMillis = momentUtcDate.valueOf();

  return dateMillis;
};

// If provided date is not of specified format, for example, just date, no time
export const unspecifiedMomentToMillis = (momentUtcDate) => {
  const dateMillis = momentUtcDate.valueOf() + momentUtcDate.utcOffset() * 60 * 1000;

  return dateMillis;
};

// If provided date is of UTC format, for example has Z at the end
export const utcMomentToMillis = (momentUtcDate) => {
  const dateMillis = momentUtcDate.valueOf();

  return dateMillis;
};

export const unspecifiedUtcDateToUtcDate = (date) => {
  const momentUtcDate = moment(date);
  const dateMillis = momentUtcDate.valueOf() - momentUtcDate.utcOffset() * 60 * 1000;

  return new Date(moment(dateMillis));
};

// If provided date is of UTC format, for example has Z at the end
export const formatMillisToDateString = (millis) => {
  if (!millis) {
    return '';
  }

  const momentUtcDate = moment(millis);

  // This format must be like this, use another method if want to use localized format
  // return momentUtcDate.utc().format(t('system:date:formats:date'));
  return momentUtcDate.utc().format('YYYY-MM-DD');
};

export const formatMillisToDisplayDateTimeString = (millis) => {
  if (!millis) {
    return '';
  }

  const momentUtcDate = moment(millis);

  // return momentUtcDate.utc().format(t('system:date:formats:dateTime'));
  return momentUtcDate.utc().format('YYYY-MM-DD HH:mm');
};

export function getFullDateInCustomTimezone(date, timeZone) {
  return moment(date)
    .tz(timeZone || 'utc')
    .format('YYYY-MM-DD HH:mm');
}

export function getDateInCustomTimezone(date, timeZone) {
  return moment(date)
    .tz(timeZone || 'utc')
    .format('YYYY-MM-DD');
}

export function getTimeInCustomTimezone(date, timeZone) {
  return moment(date)
    .tz(timeZone || 'utc')
    .format('HH:mm');
}

export const getMonth = (dateString) => {
  if (!dateString) {
    return '';
  }

  const momentUtcDate = moment(dateString);

  return momentUtcDate.utc().month();
};

export const getTodayDate = () => {
  return moment().startOf('day').format('YYYY-MM-DD');
};

export const getFirstDayOfMonth = () => {
  return moment().startOf('month').format('YYYY-MM-DD');
};

export const getLastDayOfMonth = () => {
  return moment().endOf('month').format('YYYY-MM-DD');
};
